import { observer } from "mobx-react-lite";
import { Link, NavItem } from "@menu/core/types";
import MenuContext from "@menu/core/menu.context";
import { AnalyticsType, getAnalyticTags, getDataTitleTag } from "@menu/core/lib";
import { useOpenLink } from "@menu/core/hooks";

type SubNavProps = {
    onBack?: any,
    selectedItem?: NavItem | null,
    context: MenuContext
}

const SubNav = observer((props: SubNavProps) => {
    const { context } = props;
    const openLink = useOpenLink(context);

    if (!context.displaySubMenu || !context.selectedArea || !context.selectedArea.subnavItems) {
        return null;
    }

    const getAnalytics = (link: Link) => {
        return getAnalyticTags({
            component_name: "header_secondary_nav",
            nav_item: AnalyticsType.secondLevel,
            nav_text: link.title,
            target_page_url: link.link
        });
    }

    const onClick = (e: any, link: Link) => {
        openLink(e, link, context)

        if (!context.location) {
            return;
        }

        context.clearArea();
    }

    return (<nav className="sub-menu">
        <ul>
            {context.selectedArea.subnavItems.map((x, ix) =>
                <li key={ix}
                    onClick={(e) => onClick(e, x)}
                    {...getAnalytics(x)}
                    {...getDataTitleTag(x.title)}>
                    {x.title}
                </li>)}
        </ul>
    </nav>);
});

export default SubNav;